import { ReadOnly, nn } from 'module/Common';
import { Localized } from 'module/Model/Localized';
import { Content } from 'module/Model/Content';

export type Publication = ReadOnly<Publication.Shape>;

export namespace Publication {
  export type Shape = {
    id: number;
    date: Date;
    title: Localized<string>;
    content: Content;
    descriptionEnabled: boolean;
    description: null | Localized<string>;
    headerCount: null | number;
  };

  export const isDescriptionEnabled = (model: Publication): boolean => model.descriptionEnabled;

  export const getContent = (model: Publication): Content => model.content;
  export const getTitle = (model: Publication): Localized<string> => model.title;
  export const getTitleAsText = (model: Publication): Localized<string> =>
    Localized.transform(model.title, v => v.replace('<br />', ' ').replace(/[ ]+/, ' '));

  export const getDescription = (model: Publication): Localized<string> => nn(model.description);
  export const getHeaderCount = (model: Publication): number => nn(model.headerCount);
  export const getHeaderContent = (model: Publication): Content => {
    if (!isDescriptionEnabled(model)) {
      return [];
    }
    const content = getContent(model);
    const count = getHeaderCount(model);
    if (content.length <= count) {
      return content;
    }
    return content.slice(0, count);
  };

  export const getBodyContent = (model: Publication): Content => {
    const content = getContent(model);
    if (!isDescriptionEnabled(model)) {
      return content;
    }
    const count = getHeaderCount(model);
    if (content.length <= count) {
      return [];
    }
    return content.slice(count);
  };
}



// WEBPACK FOOTER //
// ./src/module/Model/Publication/index.ts